import type {
  AddFieldOrder,
  AddFieldPlacementTarget,
  GeneratedSchemaField
} from '@cli-types/core-engine/add-field.js'
import { fieldNameOf } from './field-name-of.js'

export function insertFieldIntoTarget(
  target: AddFieldPlacementTarget,
  field: GeneratedSchemaField,
  order: AddFieldOrder = {}
): void {
  if (order.before && order.after) {
    throw new Error('Use either --before or --after, not both.')
  }

  const fields = target.getFields()

  if (order.before) {
    const index = fields.findIndex((candidate) => fieldNameOf(candidate) === order.before)
    if (index < 0) {
      throw new Error(`Field "${order.before}" was not found in ${target.label}.`)
    }
    fields.splice(index, 0, field)
    return
  }

  if (order.after) {
    const index = fields.findIndex((candidate) => fieldNameOf(candidate) === order.after)
    if (index < 0) {
      throw new Error(`Field "${order.after}" was not found in ${target.label}.`)
    }
    fields.splice(index + 1, 0, field)
    return
  }

  fields.push(field)
}
